export default {
  Title: 'Συναλλαγές EFT/POS',

  Table: {
    Toolbar: {
      Button: {
        Receipts: {
          Title: 'Παραστατικά',
          Icon : 'mdi-receipt-text-outline',
          Color: 'primary'
        },
        Export: {
          Title  : 'Εξαγωγή',
          Icon   : 'file_download',
          Color  : 'primary',
          Success: 'Σύντομα θα λάβετε αρχείο με την εξαγωγή των συναλλαγών στα email που επιλέξατε'
        },
        ResendAll: {
          Title: 'Resend All',
          Icon : 'mdi-invoice-text-send-outline',
          Color: 'primary'
        }
      }
    },

    Button: {
      View: {
        Title: 'Προβολή Συναλλαγής',
        Icon : 'remove_red_eye',
        Color: 'cyan'
      },

      Refresh: {
        Title: 'Ανανέωση Συναλλαγής',
        Icon : 'mdi-cloud-refresh-outline',
        Color: 'light-blue'
      },

      Refund: {
        Title: 'Επιστροφή Συναλλαγής',
        Icon : 'mdi-credit-card-refund',
        Color: 'purple'
      },

      Delete: {
        Title: 'Διαγραφή Συναλλαγής',
        Icon : 'delete',
        Color: 'red'
      }
    },

    Headers: {
      Id               : '#',
      TransactionId    : 'Συναλλαγή',
      OrderCode        : 'Intent Id',
      Terminal         : 'Τερματικό',
      Order            : 'Παραγγελία',
      Amount           : 'Ποσό',
      TransactionType  : 'Τύπος',
      PaymentType      : 'Μέσο Πληρωμής',
      TransactionResult: 'Αποτέλεσμα',
      TransactionStatus: 'Κατάσταση',
      Date             : 'Ημ/νία',
      Actions          : ''
    },

    Filter: {
      filterType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Τύπος',
        PlaceHolder: 'Όλες οι τύποι',
        ItemText   : 'Name',
        ItemValue  : 'Code',
        Items      : []
      },
      filterPaymentType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Μέσο Πληρωμής',
        PlaceHolder: 'Όλες τα μέσα πληρωμής',
        ItemText   : 'Name',
        ItemValue  : 'Code',
        Items      : []
      },
      filterStatus: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Κατάσταση',
        PlaceHolder: 'Όλες οι καταστάσεις',
        ItemText   : 'Name',
        ItemValue  : 'Code',
        Items      : []
      },
      filterResult: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Αποτέλεσμα',
        PlaceHolder: 'Όλες τα αποτελέσματα',
        ItemText   : 'Name',
        ItemValue  : 'Custom',
        Items      : []
      },
      filterTerminal: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Τερματικό',
        PlaceHolder: 'Όλες τα τερματικά',
        ItemText   : 'Name',
        ItemValue  : 'Code',
        Items      : []
      },
      filterTable: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Τραπέζι',
        PlaceHolder: 'Όλες τα τραπέζια',
        ItemText   : 'Name',
        ItemValue  : 'Code',
        Items      : []
      }
    }
  },

  Dialog: {
    View: {
      Toolbar: {
        Title   : 'Ιστορικό Συναλλαγής',
        Subtitle: '',
        Icon    : 'mdi-history'
      }
    },

    ResendAll: {
      Toolbar: {
        Title   : 'EFT/POS Τερματικά Πληρωμών',
        Subtitle: 'Επιλέξτε EFT/POS Τερματικό Πληρωμής',
        Icon    : 'mdi-credit-card-wireless'
      },
      Message: {
        ProcessedTransactions: 'Επεξεργασμένες Συναλλαγές: {ProcessedTransactions}'
      }
    }
  },

  Transaction: {
    Type: {
      SALE: {
        Id     : 0,
        Code   : 'SALE',
        Name   : 'ΠΩΛΗΣΗ',
        Tooltip: '',
        Icon   : 'mdi-credit-card-outline',
        Color  : 'teal'
      },
      REFUND: {
        Id     : 1,
        Code   : 'REFUND',
        Name   : 'ΕΠΙΣΤΡΟΦΗ',
        Tooltip: '',
        Icon   : 'mdi-credit-card-refund',
        Color  : 'purple'
      },
      EMPTY: {
        Id     : 2,
        Code   : 'EMPTY',
        Name   : 'ΚΕΝΟ',
        Tooltip: '',
        Icon   : 'mdi-help',
        Color  : 'grey'
      }
    },
    Status: {
      PENDING: {
        Id     : 1,
        Code   : 'PENDING',
        Name   : 'ΕΚΚΡΕΜΗΣ',
        Tooltip: 'Εκκρεμής Συναλλαγή',
        Icon   : 'mdi-clock-outline',
        Color  : 'blue-grey'
      },
      SENT: {
        Id     : 2,
        Code   : 'SENT',
        Name   : 'ΑΠΕΣΤΑΛΗ',
        Tooltip: 'Απεσταλμένη Συναλλαγή',
        Icon   : 'mdi-send-outline',
        Color  : 'light-blue'
      },
      COMPLETED: {
        Id     : 3,
        Code   : 'COMPLETED',
        Name   : 'ΟΛΟΚΛΗΡΩΜΕΝΗ',
        Tooltip: 'Ολοκληρωμένη Συναλλαγή',
        Icon   : 'mdi-check',
        Color  : 'green'
      }
    },
    Result: {
      APPROVED: {
        Id         : 1,
        Custom     : 'APPROVED',
        Code       : 'APPROVED',
        Name       : 'ΕΓΚΡΙΣΗ',
        Desc       : 'ΕΓΚΡΙΣΗ ΑΥΤΟΜΑΤΗ',
        Tooltip    : 'Η συναλλαγή έχει ολοκληρωθεί και έχει εγκριθεί.',
        Type       : 'success',
        Icon       : 'mdi-credit-card-check-outline',
        Color      : 'green',
        ColorAvatar: 'green'
      },
      APPROVED_MANUAL: {
        Id         : 1,
        Custom     : 'USER_APPROVED',
        Code       : 'APPROVED',
        Name       : 'ΕΓΚΡΙΣΗ',
        Desc       : 'ΕΓΚΡΙΣΗ ΧΕΙΡΟΚΙΝΗΤΗ',
        Tooltip    : 'Η συναλλαγή έχει ολοκληρωθεί και έχει εγκριθεί χειροκίνητα από τον χρήστη {user}.',
        Type       : 'success',
        Icon       : 'mdi-account-check',
        Color      : 'green',
        ColorAvatar: 'orange'
      },
      REVERTED_MANUAL: {
        Id         : 1,
        Custom     : 'USER_REVERTED',
        Code       : 'REVERTED',
        Name       : 'ΕΠΑΝΑΦΟΡΑ',
        Desc       : 'ΕΠΑΝΑΦΟΡΑ ΧΕΙΡΟΚΙΝΗΤΗ',
        Tooltip    : 'Η συναλλαγή έχει ολοκληρωθεί και έχει γίνει επαναφορά της χειροκίνητης έγκρισης από τον χρήστη {user}.',
        Type       : 'success',
        Icon       : 'mdi-account-check',
        Color      : 'blue',
        ColorAvatar: 'orange'
      },
      DECLINED: {
        Id         : 2,
        Custom     : 'DECLINED',
        Code       : 'DECLINED',
        Name       : 'ΑΠΟΡΡΙΨΗ',
        Desc       : 'ΑΠΟΡΡΙΨΗ',
        Tooltip    : 'Η συναλλαγή έχει ολοκληρωθεί και έχει απορριφθεί!',
        Type       : 'error',
        Icon       : 'mdi-credit-card-remove-outline',
        Color      : 'pink',
        ColorAvatar: 'pink'
      },
      CANCELLED: {
        Id         : 3,
        Custom     : 'CANCELLED',
        Code       : 'CANCELLED',
        Name       : 'ΑΚΥΡΩΣΗ',
        Desc       : 'ΑΚΥΡΩΣΗ',
        Tooltip    : 'Η συναλλαγή ακυρώθηκε από τον χρήστη του τερματικού EFT/POS.',
        Type       : 'warning',
        Icon       : 'mdi-credit-card-off-outline',
        Color      : 'darken-1 amber',
        ColorAvatar: 'darken-1 amber'
      },
      FAILED: {
        Id         : 4,
        Custom     : 'FAILED',
        Code       : 'FAILED',
        Name       : 'ΑΠΟΤΥΧΙΑ',
        Desc       : 'ΑΠΟΤΥΧΙΑ',
        Tooltip    : 'Η συναλλαγή με το τερματικό EFT/POS απέτυχε!',
        Type       : 'error',
        Icon       : 'mdi-close',
        Color      : 'red',
        ColorAvatar: 'red'
      },
      UNKNOWN: {
        Id         : 5,
        Custom     : 'UNKNOWN',
        Code       : 'UNKNOWN',
        Name       : 'ΑΓΝΩΣΤΟ',
        Desc       : 'ΑΓΝΩΣΤΟ',
        Tooltip    : 'Το αποτέλεσμα της συναλλαγής είναι άγνωστο. Το τερματικό EFT/POS δεν ανταποκρίθηκε με αποτελέσματα.',
        Type       : 'warning',
        Icon       : 'mdi-help',
        Color      : 'grey',
        ColorAvatar: 'grey'
      },
      BUSY: {
        Id         : 6,
        Custom     : 'BUSY',
        Code       : 'BUSY',
        Name       : 'ΑΠΑΣΧΟΛΗΜΕΝΟ',
        Desc       : 'ΑΠΑΣΧΟΛΗΜΕΝΟ',
        Tooltip    : 'Η συναλλαγή απέτυχε επειδή το τερματικό EFT/POS δεν είναι διαθέσιμο για συναλλαγές (είτε λόγο επεξεργασίας άλλης συναλλαγής, είτε είναι υπό συντήρηση).',
        Type       : 'warning',
        Icon       : 'mdi-credit-card-clock-outline',
        Color      : 'blue-grey',
        ColorAvatar: 'blue-grey'
      },
      MAX_TRANSACTIONS: {
        Id         : 7,
        Custom     : 'MAX_TRANSACTIONS',
        Code       : 'MAX_TRANSACTIONS',
        Name       : 'ΜΕΓΙΣΤΕΣ ΣΥΝΑΛΛΑΓΕΣ',
        Desc       : 'ΜΕΓΙΣΤΕΣ ΣΥΝΑΛΛΑΓΕΣ',
        Tooltip    : 'Το τερματικό EFT/POS έχει φτάσει στο όριο συναλλαγών για το συγκεκριμένο "πακέτο". Πρέπει να πρώτα πραγματοποιηθεί κλείσιμο "πακέτου" στο τερματικό EFT/POS για να στείλετε άλλες συναλλαγές.',
        Type       : 'warning',
        Icon       : 'mdi-numeric-off',
        Color      : 'deep-orange',
        ColorAvatar: 'deep-orange'
      },
      JOB_MAX_ATTEMPTS_EXCEEDED: {
        Id         : 0,
        Custom     : 'JOB_MAX_ATTEMPTS_EXCEEDED',
        Code       : 'JOB_MAX_ATTEMPTS_EXCEEDED',
        Name       : 'ΜΕΓΙΣΤΕΣ ΠΡΟΣΠΑΘΕΙΕΣ',
        Desc       : 'ΜΕΓΙΣΤΕΣ ΠΡΟΣΠΑΘΕΙΕΣ',
        Tooltip    : 'Η συναλλαγή δεν εκτελέστηκε! Έχει φτάσει στο μέγιστο όριο προσπαθειών εκτέλεσης.',
        Type       : 'error',
        Icon       : 'mdi-counter',
        Color      : 'orange',
        ColorAvatar: 'orange'
      },
      ERROR: {
        Id         : -1,
        Custom     : 'ERROR',
        Code       : 'ERROR',
        Name       : 'ΑΠΑΣΧΟΛΗΜΕΝΟ',
        Desc       : 'ΑΠΑΣΧΟΛΗΜΕΝΟ',
        Tooltip    : 'Ένα άλλο αίτημα προς το τερματικό είναι σε επεξεργασία, δοκιμάστε ξανά αργότερα.',
        Type       : 'error',
        Icon       : 'mdi-credit-card-clock-outline',
        Color      : 'red',
        ColorAvatar: 'red'
      }
    },
    Error: {
      AnotherRequest: 'Ένα άλλο αίτημα προς το τερματικό είναι σε επεξεργασία, δοκιμάστε ξανά αργότερα.'
    }
  }
}
